import React from 'react';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
    button: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        textAlign: 'center',
        fontSize: '14px',
        lineHeight: '1px',
        height: '32px',
        width: '120px',
        border: '1px solid',
        borderRadius: '3px',
        outline: 0,
        margin: '8px',
        borderColor: '#666',
        color: '#666',
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative',
        '&:hover': {
            backgroundColor: '#ccc'
        },
        '&:+.button': {
            marginLeft: 0
        }
    },
    buttonSecondary: {
        backgroundColor: '#666',
        borderColor: '#666',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#444',
            borderColor: '#444'
        }
    },
    buttonPrimary: {
        backgroundColor: '#4ac789',
        borderColor: '#4ac789',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#3ba770',
            borderColor: '#3ba770'
        }
    },
});

const propTypes = {
    plusStep: PropTypes.func,
    minusStep: PropTypes.func
};

class Footer extends React.Component {

    handleKeyDown(e) {
        if(this.props.keyDownEscFlag == false){
             // Enter
            if (e.keyCode == 13) {
                this.updateKeyDownEscFlag(true)
                this.goNextStep();
                this.updateKeyDownEscFlag(false)
            // esc
            } else if (e.keyCode == 27) {
                window.close();
            }
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
    }

    //親コンポーネントを呼び出す
    updateKeyDownEscFlag(bvalue) {
        return this.props.updateKeyDownEscFlag(bvalue);
    }

    //親コンポーネントを呼び出す
    goNextStep() {
        return this.props.plusStep();
    }

    //親コンポーネントを呼び出す
    goPrevStep() {
        return this.props.minusStep();
    }

    getDispButton(key,classes){

        console.log("getDispButton() in ")
        console.log(key)
        console.log(classes)

        if(key == 1){
            return(
                <div className="col-r">
                    <Button id="btn-next" className={`${classes.button} ${classes.buttonSecondary}`} onClick={() => { this.goNextStep(); }}>次へ</Button>
                </div>
            );

        }else if(key == this.props.totalstep){
            return(
                <div className="col-r">
                    <Button id="btn-prev" className={classes.button} onClick={() => { this.goPrevStep(); }}>前へ</Button>
                    <Button id="btn-next" className={`${classes.button} ${classes.buttonPrimary}`} onClick={() => { this.goNextStep(); }}>適用</Button>
                </div>
            );
        }else{
            return( 
                <div className="col-r">
                    <Button id="btn-prev" className={classes.button} onClick={() => { this.goPrevStep(); }}>前へ</Button>
                    <Button id="btn-next" className={`${classes.button} ${classes.buttonSecondary}`} onClick={() => { this.goNextStep(); }}>次へ</Button>
                </div>
            );
        }

    }

    render() {

        const { classes } = this.props;

        //ボタンの初期化
        let list = [];

        //ボタン要素の追加
        list.push(this.getDispButton(this.props.step,classes))   

        console.log(list)

        return (
            <footer className="hp" id="footer">
                <div className="footer_buttons">
                    <div className="col-l">
                        <Button id="btn-cancel" className={classes.button} onClick={() => { window.location.href = this.props.callback }}>キャンセル</Button>
                    </div>
                    {list}
                </div>
            </footer>
        );
    }
}

Footer.propTypes = propTypes;
export default withStyles(styles)(Footer);